import {gql, useMutation} from "@apollo/client";
import {
    CreateRateAgreementExport,
    CreateRateAgreementExportVariables
} from "./schema/CreateRateAgreementExport";

export type RateAgreementExport = NonNullable<
    CreateRateAgreementExport["rates"]["createRateAgreementExport"]
>;

export const createRateAgreementExportMutation = gql`
    mutation CreateRateAgreementExport($status: RateAgreementStatus!) {
        rates {
            createRateAgreementExport(status: $status) {
                exportId
                status
                fileName
                downloadUrl
                expiresAt {
                    utcDateTime
                }
            }
        }
    }
`;

export function useRateAgreementExport() {
    const [createExport, {loading}] = useMutation<
        CreateRateAgreementExport,
        CreateRateAgreementExportVariables
    >(createRateAgreementExportMutation);

    return {
        createExport,
        loading
    };
}
